/* eslint-disable camelcase */
import React from "react"
import { useSelector } from "react-redux"
import { Row, Col } from "react-bootstrap"

import { StoreType } from "client/store"
import {
    PageForm,
    FormGroup,
    Label,
    Collapse,
} from "client/components"

import FormatPercentage from "client/pages/sil/format/percentage"
import * as Formulas from "client/pages/sil/formulas"

const Form = () => {
    const device = useSelector((state: StoreType) => state.silDevice.deviceView)
    const lang = useSelector((state: StoreType) => state.system.lang)

    const sffCalculated = Formulas.sff({
        sd: device.sd,
        su: device.su,
        dd: device.dd,
        du: device.du,
    })

    const dcCalculated = Formulas.dc({
        dd: device.dd,
        du: device.du,
    })

    const iec_61508_2010 = Formulas.iec_61508_2010_device({
        type: device.type,
        mode: Formulas.getSilMode(device),
        provenInUse: device.provenInUse,
        sff: device.failureRate ? sffCalculated : device.sff,
        dc: device.failureRate ? dcCalculated : device.dc,
        lang,
    })

    const iec_61508_1998 = Formulas.iec_61508_1998_device({
        type: device.type,
        sff: device.failureRate ? sffCalculated : device.sff,
        lang,
    })

    const iec_61511_2016 = Formulas.iec_61511_2016_device({
        type: device.type,
        mode: Formulas.getSilMode(device),
        provenInUse: device.provenInUse,
        dc: device.failureRate ? dcCalculated : device.dc,
        lang,
    })

    const iec_61511_2003 = Formulas.iec_61511_2003_device({
        provenInUse: device.provenInUse,
        logicSolver: device.logicSolver,
        sff: device.failureRate ? sffCalculated : device.sff,
        lang,
    })

    return (
        <Collapse show title={lang.results}>
            <PageForm>
                <Row>
                    <Col xs={12}>
                        <FormatPercentage title={lang.sffCalculated} data={sffCalculated} />
                        <FormatPercentage title={lang.dcCalculated} data={dcCalculated} />

                        <br />
                        <FormGroup>
                            <Label>{`${device.failureRate ? lang.hardwareFailureRateYes : lang.hardwareFailureRateNo}:`}</Label>
                            {
                                device.sil
                                && <div>{lang.givenSil.replace("{0}", device.sil.toString())}</div>
                            }
                            {
                                !device.sil && (
                                    <div>
                                        <FormGroup inline>
                                            <Label row>{lang.iec_61508_2010}</Label>
                                            {iec_61508_2010}
                                        </FormGroup>
                                        <FormGroup inline>
                                            <Label row>{lang.iec_61508_1998}</Label>
                                            {iec_61508_1998}
                                        </FormGroup>
                                        <FormGroup inline>
                                            <Label row>{lang.iec_61511_2016}</Label>
                                            {iec_61511_2016}
                                        </FormGroup>
                                        <FormGroup inline>
                                            <Label row>{lang.iec_61511_2003}</Label>
                                            {iec_61511_2003}
                                        </FormGroup>
                                    </div>
                                )
                            }
                        </FormGroup>
                    </Col>
                </Row>
            </PageForm>
        </Collapse>
    )
}
export default Form
